import { jsx as _jsx } from "react/jsx-runtime";
import { useTag } from "../core/hooks.js";
import error from "../core/utils/error.js";
export default function Text({ tag, element = "p", children, ...rest }) {
    if (typeof children !== "string")
        error("Text component only accepts string children. Create a custom component for more complex types.");
    const [text, textRef] = useTag(tag, children);
    const Container = element;
    return (_jsx(Container, { ...rest, ref: textRef, children: text }));
}
